import script from "./AreaCascader.vue?vue&type=script&setup=true&name=AreaCascader&lang=ts"
export * from "./AreaCascader.vue?vue&type=script&setup=true&name=AreaCascader&lang=ts"

import "./AreaCascader.vue?vue&type=style&index=0&id=4b226292&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b226292"]])

export default __exports__